//Constant file for HomeComponents

//Constants for Card.jsx
export const INTRODUCTION = "Salut, je m'appelle";
export const MY_NAME = "The Minh Luong";
export const ROLE = "Développeur logiciel";

//Constant for About.jsx
export const ABOUT_TITLE = "À propos de moi";
export const ABOUT_LOCATION = "Montréal, Canada";
export const ABOUT_P1 = "Je suis diplômé en Génie logiciel de l’ÉTS. Passionné par la programmation et la résolution de problèmes, j’ai développé une expertise en JavaScript/TypeScript, Angular, Java et SQL, ce qui me permet de travailler sur le développement front-end, back-end et bases de données.";
export const ABOUT_P2 = "Mon objectif est d’évoluer vers un rôle de développeur senior afin de contribuer à la création de solutions logicielles complexes et à fort impact. Lors de mes stages, j’ai travaillé comme développeur Full Stack, où j’ai personnalisé des sites web et livré des solutions adaptées aux besoins variés des clients. Ces expériences ont renforcé ma capacité à m’adapter rapidement et à résoudre des défis uniques.";
export const ABOUT_P3 = "La résilience est l’une de mes plus grandes qualités : j’aborde les obstacles avec détermination et créativité, en cherchant toujours des solutions innovantes. En dehors de ma carrière professionnelle, j’aime exprimer ma créativité à travers le dessin et la photographie.";
export const BUTTON = "Expériences professionnelles";

//Constants for CSProjects.jsx
export const CS_PROJECTS_TITLE = "Projets informatique";
export const CS_PROJECTS_SUBTITLE = "Survolez les images pour voir le type de projet";
export const ACADEMIC_PROJECTS = "Projets académiques";
export const PERSONAL_PROJECTS = "Projets personnels";

//Constants for FreetimeProjects.jsx
export const FREETIME_PROJECTS_TITLE = "Projets passe-temps";
export const FREETIME_PROJECTS_SUBTITLE = "Survolez les images pour voir le type de projet";
export const ART_PROJECTS = "Projets d'art";
export const PHOTO_PROJECTS = "Projets de photographie";

//Constants for Education.jsx
export const EDUCATION_TITLE = "Éducation";
export const ETS = "ÉTS - Montréal, Canada";
export const ETS_DEGREE = "Baccalauréat en ingénierie - BE, Génie logiciel, ";
export const MAISONNEUVE = "Collège de Maisonneuve - Montréal, Canada";
export const MAISONNEUVE_DEGREE = "Sciences pures et appliquées, ";
export const COURSES_TITLE = "Cours pertinents";
export const SHOW_COURSES = "Afficher les cours";
export const HIDE_COURSES = "Cacher les cours";
export const ETS_COURSES = [
    "Programmation et Conception Orientées Objet",
    "Bases de Données à Haute Performance",
    "Structures de Données et Algorithmes",
    "Analyse et Conception de Logiciels",
    "Architecture logicielle",
    "Conception et Évaluation des Interfaces Utilisateur",
    "Technologies de développement Internet",
    "Introduction à l'approche DevOps",
    "Sécurité des logiciels",
];
